const config = {
  // Backend config
  s3: {
    REGION: import.meta.env.VITE_REGION,
    BUCKET: import.meta.env.VITE_BUCKET,
  },
  apiGateway: {
    REGION: import.meta.env.VITE_REGION,
    URL: import.meta.env.VITE_API_URL,
  },
  deduplicationApiGateway: {
    REGION: import.meta.env.VITE_REGION,
    URL: import.meta.env.VITE_DEDUPLICATION_API_URL || import.meta.env.VITE_API_URL,
    /** Dedicated deduplication API (set on deployed frontend builds). */
    isConfigured: Boolean(import.meta.env.VITE_DEDUPLICATION_API_URL?.trim()),
  },
  cognito: {
    REGION: import.meta.env.VITE_REGION,
    USER_POOL_ID: import.meta.env.VITE_USER_POOL_ID,
    APP_CLIENT_ID: import.meta.env.VITE_USER_POOL_CLIENT_ID,
    IDENTITY_POOL_ID: import.meta.env.VITE_IDENTITY_POOL_ID,
    DOMAIN: import.meta.env.VITE_DOMAIN,
  },
  pinpoint: {
    PROJECT_ID: import.meta.env.VITE_PINPOINT_PROJECT_ID || '',
  },
}

export default config
